<template>
    <div class="modal modal-slide-in chat-modal fade" :id="id">
        <div class="modal-dialog bg-white">
            <button type="button" @click="closeModal(`#${id}`)" class="close" data-dismiss="modal" aria-label="Close">×</button>
            <div class="modal-header">
                <h5 class="modal-title d-flex align-items-center">
                    Message
                </h5>
            </div>
            <div class="modal-body p-0 h-100">
                <div class="chat-app-window">
                    <div class="active-chat">
                        <div id="user-conversation" class="user-chats">
                            <div class="chats">
                                <div v-if="messageStore.conversations.isLoading" class="d-flex align-items-center justify-content-center">
                                    <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                    <span class="ml-25 align-middle">Loading...</span>
                                </div>
                                <template class="chat" v-for="conversation in messageStore.conversations.data.data">
                                    <div
                                        v-if="conversation.id"
                                        :class="{ 'chat-left': (conversation.receiver_id && conversation.receiver_id == userInfo.id || (userInfo.isTeamMember && userInfo.teams && conversation.receiver_id == userInfo.teams[0].admin.id) )}"
                                    >
                                        <div class="chat-avatar" style="position: relative;height: 40px;width: 40px;backround: white;" >
                                            <span class="avatar box-shadow-1 cursor-pointer" style="width: 100%;height: 100%; background: white;/">
                                                <p class="text-primary" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);" v-if="conversation.room_name">{{ abbreviateName(conversation.room_name) }}</p>
                                            </span>
                                        </div>

                                        <div class="chat-body">
                                            <small  class="text-muted" :class="{ 'float-left': conversation.receiver_id == userInfo.id,'float-right': conversation.receiver_id != userInfo.id }" v-if="conversation.created_at">
                                                {{ formatDate(conversation.created_at, 'LLL') }}
                                            </small>
                                            <div class="chat-content">
                                                <p v-if="conversation.message ">
                                                    {{ conversation.message }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>


                                </template>
                            </div>
                        </div>
                        <div class="chat-app-form" action="javascript:void(0);">
                            <div class="input-group input-group-merge form-send-message">
                                <input v-model="messageStore.message" type="text" class="form-control message" placeholder="Type your message" @keyup.enter="messageStore.sendMessage()"/>
                            </div>
                            <button
                                type="button"
                                class="btn btn-primary mx-1"
                                :key="messageStore.sendButtonKey"
                                id="chat-send-message"
                                @click.once="sendMessage()"

                            >
                                <template v-if="messageStore.isSending">
                                    <span class="spinner-border spinner-border-sm mr-50" role="status" aria-hidden="true"></span>
                                </template>
                                <template v-else>
                                    <vue-feather type="send" size="14" />
                                </template>
                            </button>
                        </div>
                     </div>
                    <!--<div class="row match-height" v-else>
                        <div class="col-12">
                            <h3 class="text-primary text-center mb-1">Resume from where you stopped.</h3>
                            <p class="text-center">Choose a conversation and start chatting.</p>
                            <div id="user-conversation" class="user-chats"></div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { ref,reactive } from 'vue';
    import { closeModal, openModal, formatDate} from '../../utilities/_helpers'
    import { useMessageStore } from '../../stores/MessageStore.js'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { usePlanStore } from '../../stores/PlanStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useSettingStore } from '../../stores/SettingStore.js'
    import PerfectScrollbar from 'perfect-scrollbar'
    import { BPopover } from 'bootstrap-vue-3'
    export default {
        name: 'ChatModal',
        components: {
            BPopover,
        },
        props: {
            id: String
        },
        setup(props) {
            return {
                closeModal: closeModal,
                openModal: openModal,
                messageStore: useMessageStore(),
                localizationStore: useLocalizationStore(),
                planStore: usePlanStore(),
                settingStore: useSettingStore(),
                userStore: useUserStore(),
                newChat: ref(true),
                formatDate:formatDate,
                userInfo:reactive({})
            };
        },
        mounted() {
            const $this = this;
            this.messageStore.activeChat = [];

            if(_.includes(['client-messages'], this.$route.name)){
                if(_.isEmpty(this.userStore.profile.user)){
                    this.userStore.fetchUserProfile();
                }{
                    this.userInfo = this.userStore.profile.user
                }
            }else{
                if(_.includes(['report'], this.$route.name)){
                    if(_.isEmpty(this.userStore.profile.user)){
                        this.userStore.fetchUserProfile();
                    }{
                        this.userInfo = this.userStore.profile.user
                    }
                }else{
                    if(_.isEmpty(this.userStore.user)){
                        this.userStore.fetchUser();
                    }{
                        this.userStore.fetchUser();
                        this.userInfo = this.userStore.user
                    }
                }

            }
            $this.messageStore.chats.data.length = 0;
            $this.messageStore.psConversation = new PerfectScrollbar('#user-conversation');
            
        },
        created() {
        },
        watch:{
            'messageStore.conversations'(value){
                document.getElementById("user-conversation").addEventListener('ps-y-reach-start', function () {
                        if (
                            (value.isLoading == false)
                            &&
                            !_.isNull(value.next_page_url)
                        ) {
                            $this.conversation(value.next_page_url);
                        }
                });
            },

        },
        methods: {
            sendMessage() {
                this.messageStore.sendMessage();
            },
            abbreviateName(fullname){
                return fullname.replace(/\b(\w)\w+/g, '$1.').replace(/\s/g, '').replace(/\.$/, '').toUpperCase();
            }
        },
        beforeMount() {

        }
    };
</script>
